import { Div, TextInput, RefString, Text } from "@tblabs/truffle";
import { Discount } from "../../../Services/Basket/Discount";
import { Discounter } from "../../../Services/Basket/Discounter";


export class DiscountInput extends Div
{
    constructor(discounter: Discounter)
    {
        super("");

        const userInput = new TextInput().Class("product__discount-code")
            .Placeholder("Dodatkowy kod rabatowy")

        const label = new RefString("");
        let discount: Discount | null = null;

        userInput.OnChange((code) =>
        {
            label.value = "Szukam...";
            discount = discounter.FindByCode(code);

            if (discount)
            {
                discount.IsOn.value = true;
                discounter.AddDiscount(discount);
                label.value = "✅ kod poprawny";
            }
            else
                label.value = "✖️ kod niepoprawny";
        });

        this.Append(
            userInput,
            new Text(label).MarginLeft(8)
        );
    }
}
